// import Routes
import URLRoutes from "./routes";

// Import styles
import "./App.css";
import React from "react";


function App() {
  return (
    <div>
      <URLRoutes />
    </div>
  );
}

export default App;
